import React, {Component} from 'react';
import styled from 'styled-components'
const ErrorDiv = styled.div`
  position: absolute;
  top: 4rem;
  left: 0;
  width: 70%;
  padding: 0 15%;
`

class FieldError extends Component {
    render() {
        return (
            <ErrorDiv>
                {this.props.error}
            </ErrorDiv>
        );
    }
}

export default FieldError;